import { get } from 'lodash'

import { types } from './language.actions'

type LanguageType = {
  id: string
  label: string
  tag: string
  flag: string
}

type Property = {
  languages: LanguageType[]
}

const INITIAL_STATE = {
  languages: []
}

function setState(state: Property) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_LANG]: setState(state),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
